import * as Sentry from '@sentry/react';

export const setSentryUser = (id: string, username: string, email: string): void => {
  Sentry.setUser({ id, username, email, ip_address: '{{auto}}' });
};

export const unsetSentryUser = (): void => {
  Sentry.setUser(null);
};
